export const numToPerc = (val, sum) => (val > 0 ? (val * 100) / sum : 0)
